/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/no-floating-promises */

'use client'

import React, { useEffect, useState } from 'react'
import Image from 'next/image'
import isMobile from 'ismobilejs'
import { verifyOtpSuccessCallBack } from '@utils/assethelper'
import { ChallanService } from '@services/challanServices'
import { pageEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import WidgetModal from '@components/MainWidget/common/widgetModal'
import { onDownloadApp } from '@components/MainWidget/common/helper'
import { commonWidgetConfig } from '@components/MainWidget/common/commonWidgetConfig'
import { SEGMENT } from '@components/MainWidget/common/widgetSegments'
import { useEnvVariablesClientConfig } from '@context/EnvClientContext/EnvVariablesClientContext'
import styles from './challanModal.module.scss'
import { CHALLAN_DETAIL_HEADING, CHALLAN_DETAIL_TEXT, CHALLAN_ICON_ALT, CHALLAN_MOBILE_INFO_ALT, ERROR_FETCHING, REG_CONTAINER_ALT, SCANNER_ALT, VEHICLE_CHALLAN_ALT } from './challanConstants'
import { CHALLAN_WIDGET, DOWNLOAD_APP, FETCH_URL, SCAN_TO_DOWNLOAD } from '../common/commonConstants'
import ChallanLoadingScreen from './challanLoadingScreen'
import { CAR_DEFAULT_IMG, CHALLAN_ERROR_IMG, CHALLAN_MOBILE_DESKTOP_IMG, CHALLAN_MOBILE_IMG, REG_CONGAINER } from '../common/widgetImagesConstant'
import { getChallanText } from './challanConfig'

const ChallanWidgetModal = ({
  setWidgetModal,
  vehicleData,
  regNo,
  phone,
  userData,
  segmentEventCommonProperties,
  widgetType,
  setRegNo,
  setVehicleData
}) => {
  const [challanLoadingScreen, setChallanLoadingScreen] = useState<boolean>(true)
  const [challanAmount, setChallanAmount] = useState<number>(0)
  const [challanLength, setChallanLength] = useState<number>(0)
  const [assetData, setAssetData] = useState({})

  const fetchUrl = FETCH_URL
  const envValue = useEnvVariablesClientConfig().ACKO_ENV
  const isChallanWidget = true

  useEffect(() => {
    const fetchData = async () => {
      try {
        const authResult = await verifyOtpSuccessCallBack({ regNo, phone, envValue, fetchUrl })
        setAssetData(authResult.assetData)
      } catch (error) {
        console.error(ERROR_FETCHING, error)
      }
    }
    fetchData()
  }, [])

  useEffect(() => {
   ChallanService({ regNo, setChallanAmount, setChallanLength })
  }, [])

  useEffect(() => {
    if (challanAmount !== 0) {
           pageEvent(SEGMENT.VIEW_PAGE, {
           ...segmentEventCommonProperties,
           product: commonWidgetConfig?.product?.[CHALLAN_WIDGET],
           phone: phone || userData?.phone,
           registration_number: regNo,
           vehicle_type: vehicleData?.vehicle_type,
           mm_name: vehicleData?.mm_name,
           previous_policy_expiry_date: vehicleData?.previous_policy_expiry_date,
           expiry_date: vehicleData?.expiry_date,
           vas_amount: challanAmount || null
         })
    }
  }, [challanAmount])

  return (
    <WidgetModal setWidgetModal={setWidgetModal} vehicleData={vehicleData} regNo={regNo} widgetType={CHALLAN_WIDGET} setRegNo={setRegNo} setVehicleData={setVehicleData}>
      {challanLoadingScreen ? (
        <ChallanLoadingScreen regNo={regNo} setChallanLoadingScreen={setChallanLoadingScreen} />
      ) : (
        <div className={styles.challanFinalScreen}>
          <div className={styles.challanBlob} />
          <div className={styles.challanBlob2} />
          <div className={styles.challanAlert}>
            <Image
              src={CHALLAN_ERROR_IMG}
              alt={CHALLAN_ICON_ALT}
              width={52}
              height={52}
              layout="fixed"
              priority
            />
            <h4>
              {getChallanText(challanLength, challanAmount)}
            </h4>
            <span>
              {CHALLAN_DETAIL_TEXT}
            </span>
          </div>
          <div className={styles.challanMobileScreen}>
            <div className={styles.mobileImg}>
              <Image
                src={
                  isMobile()?.phone
                    ? CHALLAN_MOBILE_IMG
                    : CHALLAN_MOBILE_DESKTOP_IMG
                }
                alt={CHALLAN_MOBILE_INFO_ALT}
                width={350}
                height={isMobile()?.phone ? 625 : 450}
                layout="fixed"
              />
            </div>

            <div className={styles.regNoContainer}>
              <h4>{assetData?.make_name || vehicleData?.db_make_name}</h4>
              <Image
                src={REG_CONGAINER}
                alt={REG_CONTAINER_ALT}
                width={130}
                height={28}
                layout="fixed"
              />
              <span>{regNo}</span>
            </div>
            <div className={styles.vehicleLogo}>
              <Image
                src={
                  assetData?.variantDetails?.logo_url ||
                  assetData?.variantDetails?.image ||
                  CAR_DEFAULT_IMG
                }
                alt={VEHICLE_CHALLAN_ALT}
                width={140}
                height={80}
                layout="fixed"
              />
            </div>
            <div className={styles.challanQrLogo}>
              <h6>{CHALLAN_DETAIL_HEADING}</h6>
              <span>{DOWNLOAD_APP}</span>
              <div className={styles.scannerBox}>
                <Image
                  src={commonWidgetConfig.scannerImg[widgetType]}
                  alt={SCANNER_ALT}
                  width={125}
                  height={125}
                />
                <p>{SCAN_TO_DOWNLOAD}</p>
              </div>
            </div>
          </div>
          <div className={styles.challanDownloadBtn}>
            <div
              className={styles.downloadBtn}
              onClick={() => onDownloadApp({ regNo, segmentEventCommonProperties, widgetType, phone, userData, vehicleData, isChallanWidget, challanAmount }) }>
              <span>{DOWNLOAD_APP}</span>
            </div>
          </div>
        </div>
      )}
    </WidgetModal>
  )
}

export default ChallanWidgetModal
